import { Separator } from 'components'
import { Icons } from 'utils/icons'
import { IPetAfterSales } from 'store/afterSales/types'

import { Text } from '@interco/inter-ui/components/Text'
import { Flex } from '@interco/inter-ui/components/Flex'
import { Alert } from '@interco/inter-ui/components/Alert'

import { PetPlanCard } from './PetPlanCard'
import { PrintPetPlanCardWrapper, Weekdays } from './AfterSalesDetails.styles'

interface PrintPetPlanCardProps {
  afterSalesPet: IPetAfterSales
}

export const PrintPetPlanCard = ({ afterSalesPet }: PrintPetPlanCardProps) => {
  const contactIcons = {
    desktop: <Icons.Desktop width={16} height={16} color="var(--gray500)" />,
    email: <Icons.Email width={16} height={16} color="var(--gray500)" />,
    phone: <Icons.Phone width={16} height={16} color="var(--gray500)" />,
  }

  return (
    <PrintPetPlanCardWrapper id="print-pet-subscription-card">
      <PetPlanCard
        hideShare
        type={afterSalesPet.type}
        name={afterSalesPet.name}
        status={afterSalesPet.status}
        planName={afterSalesPet.planName}
        socialId={afterSalesPet.socialId}
        petDateBirth={afterSalesPet.petDateBirth}
      />
      <Alert type="grayscale">
        Lembre-se: no Plano Pet do Inter não é necessário microchipar seu pet para usar o plano.
        Basta informar seu CPF no momento da utilização.
      </Alert>
      <Flex direction="row" style={{ marginTop: '24px' }}>
        <Text variant="body-1" bold color="var(--gray500)">
          Contato
        </Text>
      </Flex>
      <Separator type="solid" borderWidth="1px" color="var(--gray200)" margin="16px 0" />
      <Flex
        direction="row"
        justifyContent="flex-start"
        alignContent="flex-start"
        alignItems="center"
        gap="8px"
      >
        {contactIcons.desktop}
        <Text variant="caption-1" className="contactInfo" bold>
          www.saude.petlove.com.br
        </Text>
      </Flex>
      <Flex
        direction="row"
        justifyContent="flex-start"
        alignContent="flex-start"
        alignItems="center"
        gap="8px"
      >
        {contactIcons.email}
        <Text variant="caption-1" className="contactInfo" bold>
          contato@petlovesaude.com.br
        </Text>
      </Flex>
      <Flex
        direction="row"
        justifyContent="flex-start"
        alignContent="flex-start"
        alignItems="center"
        gap="8px"
      >
        {contactIcons.phone}
        <Text variant="caption-1" className="contactInfo" bold>
          3003-7190
        </Text>
      </Flex>

      <Weekdays>
        <Text variant="caption-1" as="p" bold>
          Atendimento:
        </Text>
        <Text variant="caption-1">
          De segunda a sexta, das 08h às 21h
          <br />
          Aos sábados, das 08h às 17h
        </Text>
      </Weekdays>
    </PrintPetPlanCardWrapper>
  )
}
